import { Component, OnInit, ViewChild } from '@angular/core';
import { CardModule } from 'primeng/card';
import { SelectModule } from 'primeng/select';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from 'primeng/tabs';
import { User } from '../../../user/models/user.type';
import { TaxonomyTab } from '../../model/taxonomy-tab';
import { TaxonomyCategoriesComponent } from '../taxonomy-categories/taxonomy-categories.component';
import { TaxonomyAttributesComponent } from '../taxonomy-attributes/taxonomy-attributes.component';
import { UserService } from '../../../user/services/user.service';
import { CommonModule } from '@angular/common';
import { ChannelService } from '../../../import/service/channel.service';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CategoryService } from '../../../import/service/category.service';

@Component({
  selector: 'app-taxonomy-details',
  standalone: true,
  imports: [
    CardModule,
    SelectModule,
    Tabs, TabList, Tab, TabPanels, TabPanel,
    CommonModule,
    FormsModule,
    TranslateModule,
    TaxonomyCategoriesComponent,
    TaxonomyAttributesComponent,
  ],
  templateUrl: './taxonomy-details.component.html',
  styleUrl: './taxonomy-details.component.scss',
  providers: [UserService],
})
export class TaxonomyDetailsComponent implements OnInit {
  user: User;

  tabs: TaxonomyTab[] = [
    { label: 'global.categories', componentTxt: 'category' },
    { label: 'global.attributes', componentTxt: 'attributes' },
  ];

  channels;
  selectedChannel;
  locales;
  selectedLocale;
  categories;
  categoriesAttribute;

  @ViewChild('taxonomyCategory') taxonomyCategory: TaxonomyCategoriesComponent;

  constructor(
    private readonly userService: UserService,
    private readonly channelService: ChannelService,
    private readonly categoryService: CategoryService,
  ) {}

  ngOnInit(): void {
    this.user = this.userService.getUser();
    if (this.userService.hasRole(['ROLE_SUPER_ADMIN', 'ROLE_OPERATOR', 'ROLE_OPERATOR_ADMIN'])) {
      this.channels = this.user.relatedChannels;
    } else {
      const setObj = this.user?.relatedShops?.map((shop) => shop.shopChannel);
      this.channels = Array.from(new Set(setObj?.map((channel) => JSON.stringify(channel)))).map((channel) =>
        JSON.parse(channel),
      );
    }
    this.selectedChannel = this.channelService.getSelectedChannel();
    this.initLocales();
  }

  initLocales() {
    this.channelService.getLocales(this.selectedChannel).subscribe({
      next: (res: any) => {
        this.locales = res.locales;
        this.selectedLocale = this.locales[0];
        this.channelService.setSelectedLocale(this.selectedLocale);
        this.initCategories();
      },
    });
  }

  initCategories() {
    this.categoryService.getCategories().subscribe({
      next: (res) => {
        const categories = structuredClone(res);
        const categoriesAttribute = structuredClone(res);
        this.categories = this.categoryService.getCaterogyByLocale(categories, this.selectedLocale);
        for (let node of this.categories) {
          this.handleSlectableNodes(node);
        }
        this.categoriesAttribute = this.categoryService.getCaterogyByLocale(categoriesAttribute, this.selectedLocale);
        for (let node of this.categoriesAttribute) {
          this.handleSlectableNodes(node);
        }
        this.taxonomyCategory.finishLoading();
      },
    });
  }

  handleSlectableNodes(node) {
    if (node.hasChildren == 'true') {
      node.selectable = false;
      for (let child of node.children) {
        this.handleSlectableNodes(child);
      }
    }
  }

  filterChannel() {
    this.taxonomyCategory.ngOnInit();
    this.channelService.setSelectedChannel(this.selectedChannel);
    this.initLocales();
  }

  updateLocale() {
    this.taxonomyCategory.ngOnInit();
    this.channelService.setSelectedLocale(this.selectedLocale);
    this.initCategories();
  }
}
